/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

	// Use this variable to set up the common and page specific functions. If you
	// rename this variable, you will also need to rename the namespace below.
	var Sage = {
		// All pages
		'common': {
			init: function() {
				// JavaScript to be fired on all pages

				$('.hero').fadeTo(1000, 1);

				$('.mobile-nav-toggle').click(function(e) {
					e.preventDefault();
					if ($('header').hasClass('opened')) {
						collapseMenu();
					}else{
						expandMenu();
					}
				});

				$('.overlay').click(function(e) {
					e.preventDefault();
					collapseMenu();
				});

				$('.page-nav .menu-item a, .nav-primary .menu-item a').click(function(e) {
					var href = $(this).attr('href');
					if (href.indexOf('#') == 0) {
						e.preventDefault();
						collapseMenu();
						scrollToId(href);
					}
				});

				$('*[data-scrolltoid]').click(function(e) {
					e.preventDefault();
					scrollToId($(this).data('scrolltoid'));
				});

				if ($('.spectacle-archived-group .spectacle').length == 0) {
					$('.spectacle-archived-trigger').hide(0);
				}
				$('.spectacle-archived-trigger').click(function(e) {
					e.preventDefault();
					$('.spectacle-hidden').removeClass('spectacle-hidden');
					$('.spectacle-archived-group').fadeIn(500);
					$(this).hide(0);
				});

				/**
				 * external links 
				 */
				$("a[href^='http']").not("a[href^='http:\/\/"+window.location.hostname+"']").each(function(){
					$(this).attr("target", "_blank");
				});

				/**
				 * PDF files
				 */
				$("a[href$='pdf']").each(function(){
					$(this).attr("target", "_blank");
				});

				var s = skrollr.init({
					mobileCheck: function() {
						return false;
					}
				});

			},
			finalize: function() {
				// JavaScript to be fired on all pages, after page specific JS is fired
			}
		},
		// Home page
		'home': {
			init: function() {
				// JavaScript to be fired on the home page
			},
			finalize: function() {
				// JavaScript to be fired on the home page, after the init JS
			}
		},
		// About us page, note the change from about-us to about_us.
		'about_us': {
			init: function() {
				// JavaScript to be fired on the about us page
			}
		}
	};

	function scrollToId(id) {
		var target_top = $(id).offset().top;
		$("html, body").animate({ scrollTop: target_top + 'px' });
	};

	function expandMenu() {
		$('header').addClass('opened');
		$('.overlay').addClass('active');
	};

	function collapseMenu() {
		$('header').removeClass('opened');
		$('.overlay').removeClass('active');
	};

	// The routing fires all common scripts, followed by the page specific scripts.
	// Add additional events for more control over timing e.g. a finalize event
	var UTIL = {
		fire: function(func, funcname, args) {
			var fire;
			var namespace = Sage;
			funcname = (funcname === undefined) ? 'init' : funcname;
			fire = func !== '';
			fire = fire && namespace[func];
			fire = fire && typeof namespace[func][funcname] === 'function';

			if (fire) {
				namespace[func][funcname](args);
			}
		},
		loadEvents: function() {
			// Fire common init JS
			UTIL.fire('common');

			// Fire page-specific init JS, and then finalize JS
			$.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
				UTIL.fire(classnm);
				UTIL.fire(classnm, 'finalize');
			});

			// Fire common finalize JS
			UTIL.fire('common', 'finalize');
		}
	};

	// Load Events
	$(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.



  // Polyfill for requestAnimationFrame
  // via: https://gist.github.com/paulirish/1579671

  (function() {
    var lastTime = 0;
    var vendors = ['ms', 'moz', 'webkit', 'o'];
    for(var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
      window.requestAnimationFrame = window[vendors[x]+'RequestAnimationFrame'];
      window.cancelAnimationFrame = window[vendors[x]+'CancelAnimationFrame']
        || window[vendors[x]+'CancelRequestAnimationFrame'];
    }

    if (!window.requestAnimationFrame)
      window.requestAnimationFrame = function(callback) {
        var currTime = new Date().getTime();
        var timeToCall = Math.max(0, 16 - (currTime - lastTime));
        var id = window.setTimeout(function() { callback(currTime + timeToCall); },
          timeToCall);
        lastTime = currTime + timeToCall;
        return id;
      };

    if (!window.cancelAnimationFrame)
      window.cancelAnimationFrame = function(id) {
        clearTimeout(id);
      };
  }());